import { Card, CardContent, CardMedia } from "@mui/material";
import config from "../config";
import { WoList } from "../models/ResponseModels/SearchResponse";
import { useNavigate } from "react-router-dom";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import { useEffect, useState } from "react";
import { PostFollowModel } from "../models/PostFollowModel";

interface WorkorderCardProps {
  item: WoList;
  index: number;
}

export default function WorkorderCard({ item, index }: WorkorderCardProps) {
  const navigate = useNavigate();
  const [starIcon, setStarIcon] = useState<any>(<StarBorderIcon />);
  const [action, setAction] = useState<string>("follow");

  useEffect(() => {
    if (item.isFollowed !== null && item.isFollowed == true) {
      // se il contenuto è seguito dall'utente corrente, allora l'azione sarà di unfollow
      setAction("unfollow");
      setStarIcon(<StarIcon />);
    }
  }, []);

  function openWorkOrderPage(uuid: string, imageUrl: string) {
    const parameters = {
      previewImageUrl: imageUrl,
    };
    navigate("/details/" + uuid, { state: JSON.stringify(parameters) });
  }

  function follow() {
    let response = null;

    console.log("Starting API call PostFollowModel...");
    (async () => {
      response = await PostFollowModel(item.workorderId, action);
      //console.log("PostFollowModel response: "+JSON.stringify(response));

      let responseData = response?.data;
      let statusCode = response?.status;

      if (responseData === undefined) {
        return;
      }

      statusCode = 200;
      responseData.code = "1";
      if (statusCode == 200) {
        if (responseData.code === "1") {
          //change action after follow/unfollow
          const actionName = action !== "follow" ? "follow" : "unfollow";
          setAction(actionName);
          //filled icon: content actually followed , empty icon: content actually unfollowed
          const icon =
            actionName !== "follow" ? <StarIcon /> : <StarBorderIcon />;
          setStarIcon(icon);

          console.log(actionName);
        }
      } else {
      }

      return;
    })();
  }

  return (
    <Card
      className="mx-auto cursor-pointer"
      sx={{ width: 310, height: 310 }}
      key={"wo_" + index}
      onClick={() => openWorkOrderPage(item.workorderId, item.imageUrl)}
    >
      <CardMedia
        sx={{
          height: 140,
          backgroundImage: `url(${
            item.imageUrl != null
              ? config.cloudfrontImgUrl +
                "" +
                item.imageUrl +
                config.showImagesQuery
              : config.placeholderImageUrl
          })`,
          backgroundSize: "contain",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
        key={"wo_card_media" + index}
      />
      <CardContent key={"wo_card_content" + index}>
        <div className="text-base min-h-11 line-clamp-2 font-skyMedium">
          {item.title}
        </div>
        <div
          id="content-info"
          className={`text-base min-h-11 text-gray-400  line-clamp-2 font-skyMedium ${
            item.contentType != null ? "visible" : "invisible"
          } `}
        >
          {item.contentType
            ? item.contentType === config.contentType.Episode
              ? "Episode"
              : item.contentType
            : ""}{" "}
          {item.contentType === config.contentType.Season && item.seriesNumber
            ? item.seriesNumber
            : ""}
          {item.contentType === config.contentType.Episode && item.episodeNumber
            ? item.episodeNumber
            : ""}
          {item.contentType === config.contentType.Episode && item.seriesNumber
            ? " of Season " + item.seriesNumber
            : ""}
        </div>
        <div className="container-flags mt-4 grid grid-rows-2 grid-cols-2 h-1/2">
          <div id="followers " className="text-sky-400  font-skyRegular">
            {item.follower} followers
          </div>
          <div
            className={`${
              item.isFollowed != null ? "block" : "hidden"
            } text-right pr-1.5 text-sky-400  `}
            onClick={(event) => {
              event.stopPropagation();
              follow();
            }}
            title={action === "follow" ? "Follow" : "Unfollow"}
          >
            {starIcon}
          </div>

          <div
            id="status"
            className={`${
              item.isPlaceholder == true ? "visible" : "invisible"
            } `}
          >
            Awaiting Assets
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
